export const LOADING = Symbol('LOADING')
export const ADD = Symbol('ADD')
export const UPDATE = Symbol('UPDATE')
export const DELETE = Symbol('DELETE')
export const LIST = Symbol('LIST')
export const ALL = Symbol('ALL')
export const DETAILS = Symbol('DETAILS')
export const SET_FILTER = Symbol('SET_FILTER')
export const RESET_FILTER = Symbol('RESET_FILTER')